import { Link, Typography } from '@carto/meridian-ds/components'
import { Box, styled } from '@mui/material'
import ProviderIcon from 'features/common/ui/ProviderIcon/ProviderIcon'
import { FormattedMessage } from 'react-intl'
import { ProviderType } from '../types'
import { DOCS_CONNECTIONS } from 'app/constants/urls'
import { PowerOffOutlined } from '@mui/icons-material'
import NoConnectionsTooltip from './NoConnectionsTooltip'
import ConnectionsNewButton from './ConnectionsNewButton'

const ProvidersList = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  '& > *': {
    marginRight: theme.spacing(1)
  }
}))

const LinkComponent = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.contrastText
}))

interface NoConnectionsOrCdwPlaceholderProps {
  hasAvailableProviders: boolean
}

function NoConnectionsOrCdwPlaceholder({ hasAvailableProviders }: NoConnectionsOrCdwPlaceholderProps) {
  const button = (
    <ConnectionsNewButton
      label={<FormattedMessage id="connections.createYourFirstConnection" />}
      disabled={!hasAvailableProviders}
      placement="top"
    />
  )

  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="60vh" width="100%">
      <Box maxWidth="50%" textAlign="center">
        <Box>
          <PowerOffOutlined fontSize="inherit" sx={{ fontSize: '37px' }} color="disabled" />
        </Box>
        <Box>
          <Typography variant="body1" color="textSecondary">
            <FormattedMessage id="connections.emptyState" />
          </Typography>
          <Typography variant="body2" color="textSecondary">
            <FormattedMessage id="connections.connectionsListBanner.prompt" />
          </Typography>
          <ProvidersList display="flex" justifyContent="center">
            <ProviderIcon provider={ProviderType.SNOWFLAKE} />
            <ProviderIcon provider={ProviderType.BIGQUERY} />
            <ProviderIcon provider={ProviderType.DATABRICKS} />
            <ProviderIcon provider={ProviderType.POSTGRES} />
            <ProviderIcon provider={ProviderType.REDSHIFT} />
          </ProvidersList>
        </Box>
        <Box mt={3}>{!hasAvailableProviders ? <NoConnectionsTooltip button={button} placement="top" /> : button}</Box>
        <Box mt={1}>
          <LinkComponent href={DOCS_CONNECTIONS} external variant="caption">
            <FormattedMessage id="workflows.analyticsToolbox.componentTreeInfo.learnMore" />
          </LinkComponent>
        </Box>
      </Box>
    </Box>
  )
}

export default NoConnectionsOrCdwPlaceholder
